import { useMemo } from "react";

const useMapProjection = (
  map?: google.maps.Map,
  bounds?: google.maps.LatLngBounds | null,
  projection?: google.maps.Projection | null,
  coordinates?: google.maps.LatLng | google.maps.LatLngLiteral,
  visible?: boolean
): {
  left: number;
  top: number;
  visibility: "hidden" | "visible";
} => {
  return useMemo(() => {
    if (coordinates && visible && map && bounds && projection) {
      const topRight = projection.fromLatLngToPoint(bounds.getNorthEast());
      const bottomLeft = projection.fromLatLngToPoint(bounds.getSouthWest());
      const scale = Math.pow(2, map.getZoom() ?? 0);
      const point = projection.fromLatLngToPoint(coordinates);

      if (point && topRight && bottomLeft) {
        return {
          left: Math.floor((point.x - bottomLeft.x) * scale),
          top: Math.floor((point.y - topRight.y) * scale),
          visibility: "visible",
        };
      }
    }

    return {
      left: 0,
      top: 0,
      visibility: "hidden",
    };
  }, [map, bounds, projection, coordinates, visible]);
};

export default useMapProjection;
